import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormControl, FormGroup,} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from '../../../../infrastructure/decorators/auto-unsubscribe.decorator';
import {FinanceReportFilterResult} from '../../model/finance-report-filter-result';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {Subscription} from 'rxjs';
import {DynamicAutocompleteItem} from '../../service/dynamic-autocomplete/dynamic-autocomplete.service';

@AutoUnsubscribe()
@Component({
    selector: 'finance-reports-filter-modal',
    templateUrl: './finance-reports-filter-modal.component.html',
    standalone: false
})
export class FinanceReportsFilterModalComponent implements OnInit {
  @Input() config!: FinanceReportFilterResult;

  breakPoint$?:Subscription;
  isSmall: boolean = false;

  constructor(
    @Optional() public dialogRef: MatDialogRef<FinanceReportsFilterModalComponent>,
    breakpointObserver: BreakpointObserver,
  ) {
      this.breakPoint$ = breakpointObserver.observe([
        Breakpoints.Medium,
        Breakpoints.Small,
        Breakpoints.XSmall
      ]).subscribe(result => {
          this.isSmall = result.matches;
      });
  }

  form: FormGroup = new FormGroup({
    bookingStartFrom: new FormControl(null),
    bookingStartTo: new FormControl(null),
    bookingEndFrom: new FormControl(null),
    bookingEndTo: new FormControl(null),
    dateCreatedFrom: new FormControl(null),
    dateCreatedTo: new FormControl(null),
    advisorName: new FormControl<DynamicAutocompleteItem | null>(null),
    tripReference: new FormControl<DynamicAutocompleteItem | null>(null)
  });

  handleClose() {
    if (!this.dialogRef) {
      return;
    }
    this.dialogRef.close(null);
  }

  ngOnInit() {
    this.updateFormFromConfig();
  }

  private updateFormFromConfig() {
    const { bookingStartFrom, bookingStartTo, bookingEndFrom, bookingEndTo, dateCreatedFrom, dateCreatedTo, advisorName, tripReference} = this.config ?? {};
    
    let advisorNameValue: DynamicAutocompleteItem | null = null;
    if (typeof advisorName === 'string' && advisorName) {
      advisorNameValue = { value: advisorName, originalValue: advisorName };
    } else if (advisorName && typeof advisorName === 'object') {
      advisorNameValue = advisorName;
    }
    
    let tripReferenceValue: DynamicAutocompleteItem | null = null;
    if (typeof tripReference === 'string' && tripReference) {
      tripReferenceValue = { value: tripReference, originalValue: tripReference };
    } else if (tripReference && typeof tripReference === 'object') {
      tripReferenceValue = tripReference;
    }
    
    this.form.patchValue({
      bookingStartFrom, 
      bookingStartTo, 
      bookingEndFrom, 
      bookingEndTo, 
      dateCreatedFrom, 
      dateCreatedTo, 
      advisorName: advisorNameValue, 
      tripReference: tripReferenceValue
    });
  }


  applyFinanceReportFilters() {
    const formValues = this.form.value;
    
    let advisorNameValue = formValues.advisorName;
    if (typeof advisorNameValue === 'object' && advisorNameValue !== null) {
      advisorNameValue = advisorNameValue.value || advisorNameValue.AgentName || advisorNameValue.agentName || '';
    }
    
    let tripReferenceValue = formValues.tripReference;
    if (typeof tripReferenceValue === 'object' && tripReferenceValue !== null) {
      tripReferenceValue = tripReferenceValue.value || tripReferenceValue.ExternalReference || tripReferenceValue.externalReference || '';
    }
    
    this.config = {
      bookingStartFrom: formValues.bookingStartFrom,
      bookingStartTo: formValues.bookingStartTo,
      bookingEndFrom: formValues.bookingEndFrom,
      bookingEndTo: formValues.bookingEndTo,
      dateCreatedFrom: formValues.dateCreatedFrom,
      dateCreatedTo: formValues.dateCreatedTo,
      advisorName: advisorNameValue?.trim ? advisorNameValue.trim() : advisorNameValue,
      tripReference: tripReferenceValue?.trim ? tripReferenceValue.trim() : tripReferenceValue
    };

    if (this.form.invalid) {
      this.form.markAllAsTouched();
    }
    else if (this.dialogRef) {
      this.dialogRef.close(this.config);
    }
  }

  public clearFinanceReportFilters(propertyName: string): void {
    if (propertyName === "all") {
      this.config = {} as FinanceReportFilterResult;
      this.form.reset();
    }
    else{
      this.form.get(propertyName)?.setValue(null);
      
      const temp = { ...this.config };
      delete temp[propertyName as keyof FinanceReportFilterResult];
      this.config = temp;
    }
  }
}
